function mergeObjects(defaults, options) {
    if (options === null || defaults === null) {
        return defaults;
    }

    for (let key in options) {
        defaults[key] = options[key];
    }

    return defaults;
}

/**
 * returns the width of an element.
 * @param el HTMLElement
 * @return {number}
 */
function  getElementWidth(el) {
    if (!el) return 0;
    return parseFloat(getComputedStyle(el, null).width.replace("px", ""));
}

/**
 * returns the height of an element.
 * @param el HTMLElement
 * @return {number}
 */
function  getElementHeight(el) {
    if (!el) return 0;
    return parseFloat(getComputedStyle(el, null).height.replace("px", ""));
}

function addUrlHashParameter(initialUrl, key, value) {
    let url = removeUrlHashParameter(initialUrl, key),
        fragments = url.split('#'),
        urlpart = fragments[0],
        hashparts = fragments.length>1? fragments[1].split("&") : [],
        result;

    hashparts.push(encodeURIComponent(key) + "=" + encodeURIComponent(value));

    if (hashparts.length>0) {
        result = urlpart + '#' + hashparts.join('&');
    } else {
        result = urlpart;
    }

    return result;
}

function getUrlHashParameterValue(url, key) {
    let fragments=url.split('#'),
        hashparts = fragments.length>1? fragments[1].split("&") : [],
        result;

    if (hashparts.length>0)
    {
        let prefix= encodeURIComponent(key)+'=';

        for (let i=0; i<hashparts.length; i++) {
            if (hashparts[i].indexOf(prefix, 0) === 0) {
                result = hashparts[i].replace(prefix, '');
            }
        }
    }

    return result;
}

function removeUrlHashParameter(url, key) {
    let fragments=url.split('#'),
        urlpart= fragments[0],
        hashparts = fragments.length>1? fragments[1].split("&") : [],
        result;

    if (hashparts.length>0)
    {
        let prefix= encodeURIComponent(key)+'=',
            newHashParts = [];

        for (let i=0; i<hashparts.length; i++) {
            if (hashparts[i].indexOf(prefix, 0) !== 0) {
                newHashParts.push(hashparts[i]);
            }
        }
        hashparts = newHashParts;
    }

    if (hashparts.length>0) {
        result = urlpart + '#' + hashparts.join('&');
    } else {
        result = urlpart;
    }

    return result;
}

/**
 *
 * @param node HTMLElement
 * @return HTMLElement[]
 */
function getParents(node) {
    let parents = [];

    if (node === null) {
        return parents;
    }

    while(node.parentElement != null) {
        let parent = node.parentElement;
        parents.push(parent);
        node = parent;
    }
    return parents;
}

/**
 * Search the parent matching a selector and return it.
 *
 * @param node HTMLElement
 * @param query string
 */
function getParent(node, query) {
    let nodes = getParents(node);
    for (let i = 0; i < nodes.length; i++) {
        if (nodes[i].matches(query)) {
            return nodes[i];
        }
    }
    return null;
}

/**
 * Loops over an array and executes the callback with it.
 *
 * @param elements array
 * @param callback Function
 * @return int number of executions of the callback method.
 */
function forEach(elements, callback) {
    if (!elements) {
        return 0;
    }
    for(let i=0; i<elements.length; i++) {
        callback(elements[i], i);
    }

    return elements.length
}
export const Helpers = { addUrlHashParameter, mergeObjects, getElementWidth, getElementHeight, getUrlHashParameterValue, removeUrlHashParameter, getParents, getParent, forEach };
